import { render, staticRenderFns } from "./OTDList.vue?vue&type=template&id=734e877e&scoped=true&"
import script from "./OTDList.vue?vue&type=script&lang=js&"
export * from "./OTDList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e877e",
  null
  
)

export default component.exports